import { instance4 } from "App/constants";

export const AccessActions = {
  ACCESS_UPDATE_SEP: "ACCESS_UPDATE_SEP",
  ACCESS_DELETE_SEP: "ACCESS_DELETE_SEP",
};

export const AccessInitialState = {
  access_update_sep: false,
  access_delete_sep: false,
};

export const getAcccessSIMRS = async (code, level = 1) => {
  try {
    const response = await instance4.get(
      `/wmsSetting/user_validasi/cek-akses-user?code=${code}&level=${level}`
    );

    if (response.data.status === 200) {
      return {
        state: true,
        data: response.data.data,
      };
    } else {
      return {
        state: false,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      data: [],
    };
  }
};

export const getAccessUpdateSEP = () => {
  return (dispatch) => {
    getAcccessSIMRS("BTN_UPDATE_SEP").then((response) => {
      dispatch({
        type: AccessActions.ACCESS_UPDATE_SEP,
        payload: response.data,
      });
    });
  };
};

export const getAccessDeleteSEP = () => {
  return (dispatch) => {
    getAcccessSIMRS("BTN_DELETE_SEP").then((response) => {
      dispatch({
        type: AccessActions.ACCESS_DELETE_SEP,
        payload: response.data,
      });
    });
  };
};
